/*
 * @Author: your name
 * @Date: 2021-05-18 12:21:12
 * @LastEditTime: 2021-07-28 10:33:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue_admin\src\store\modules\settings.js
 */
import defaultSettings from '@/settings'
const { showSettings, tagsView, fixedHeader, sidebarLogo, title } = defaultSettings

const getDefaultState = () => {
  return {
    showSettings: showSettings,
    tagsView: tagsView,
    fixedHeader: fixedHeader,
    sidebarLogo: sidebarLogo,
    projectTitle: title,
    projectName: title
  }
}

const state = getDefaultState()

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  CHANGE_TITLE: (state, value) => {
    state.projectTitle = value
  },
  CHANGE_NAME: (state, value) => {
    state.projectName = value
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  changeTitle({ commit }, value) {
    commit('CHANGE_TITLE', value)
  },
  changeName({ commit }, value) {
    commit('CHANGE_NAME', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

